import { SvgIcon } from "@mui/material";
import React from "react";

function BellIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18.3476C17.6392 18.3476 20.2481 17.6242 20.5 14.7205C20.5 11.8188 18.6812 12.0054 18.6812 8.44511C18.6812 5.66414 16.0452 2.5 12 2.5C7.95477 2.5 5.31885 5.66414 5.31885 8.44511C5.31885 12.0054 3.5 11.8188 3.5 14.7205C3.75295 17.6352 6.36177 18.3476 12 18.3476Z"
        stroke="#2D2F39"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        id="Stroke 3"
        d="M14.3889 21.3574C13.0247 22.8721 10.8967 22.8901 9.51953 21.3574"
        stroke="#2D2F39"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default BellIcon;
